export const defaultSiteData = {
  customPages: [],
  branding: {
    name: "Champions' Leadership Global",
    logoUrl: "https://ijsr.org.ng/wp-content/uploads/2026/03/CLG2.png",
    tagline: "Raising Transformational Leaders",
    email: "championscorner27@gmail.com",
    phone: "+234 906 414 4546",
    whatsApp: "https://wa.me/2348107772854",
    formAction: "https://formspree.io/f/mqeykgyy",
    contactInfoText: "championscorner27@gmail.com · +234 906 414 4546",
    footerDesc: "Empowering individuals to discover their purpose and lead with lasting, generational impact.",
    copyrightText: "© 2026 Champions' Leadership Global. All rights reserved."
  },
  hero: {
    bgImage: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=2000",
    eyebrow: "Welcome to a World of Champions",
    titleLine1: "Raising",
    titleHighlight: "Transformational",
    titleLine3: "Leaders",
    sub: "Empowering individuals to discover their purpose and lead with lasting, generational impact.",
    quote: "You can choose your actions; not consequences",
    quoteAuthor: "Jerry Oyedele",
    primaryBtnText: "Explore Our Mission",
    secondaryBtnText: "Book a Session →",
    marqueeItems: [
      "Purpose Discovery",
      "Leadership Development",
      "Intentional Living",
      "Character Formation",
      "Champions Conference",
      "Personal Transformation"
    ]
  },
  statsSection: {
    label: "Our Impact So Far",
    title: "Every Number Tells",
    titleHighlight: "a Story",
    items: [
      { id: "stat-1", num: "2", suffix: "+", label: "Years of Impact", desc: "Years of raising transformational leaders", icon: "📅" },
      { id: "stat-2", num: "1K", suffix: "+", label: "Lives Transformed", desc: "Individuals impacted through our programmes", icon: "🌱" },
      { id: "stat-3", num: "6", suffix: "", label: "Core Team Members", desc: "Dedicated champions driving the vision", icon: "🤝" },
      { id: "stat-4", num: "6", suffix: "", label: "Core Values", desc: "Principles guiding everything we do", icon: "🧭" }
    ],
    bannerTitle: "Need clarity on purpose, identity, and leadership?",
    bannerSub: "Join others who have unlocked their potential.",
    bannerBtnText: "Book a Session →"
  },
  aboutSection: {
    label: "Our Story",
    title: "About Champions' Leadership Global",
    p1: "Champions' Leadership Global is a brand deeply committed to the themes of purpose, leadership, and personal development. We exist to raise a generation of individuals who are not merely successful in the world's eyes but are truly fulfilled in their God-given assignment.",
    p2: "We believe that everyone has the potential and responsibility to live out their purpose, and we aim to inspire and enlighten individuals on this journey. Our work is rooted in the conviction that the world's greatest problems are not structural — they are leadership problems, and leadership problems are ultimately people problems.",
    p3: "Founded out of a personal experience of purpose discovery, Champions' Leadership Global was born to serve as a catalyst — a space where people encounter the truth about themselves, are equipped for their life's work, and are connected to a community of like-minded champions.",
    quote: "Transforming people is the best way to transform the world, because the world is first a people, which eventually makes the place.",
    visionTitle: "Our Vision",
    visionDesc: "A world where every individual walks in the full expression of their God-given purpose — leading families, organisations, communities, and nations with wisdom, integrity, and lasting impact.",
    missionTitle: "Our Mission",
    missionDesc: "To discover, develop, and deploy transformational leaders through intentional programmes, platforms, and partnerships that foster purpose, character, and excellence in every sphere of life."
  },
  coreValues: {
    label: "What We Stand For",
    title: "Our Core Values",
    subtitle: "These values are not aspirations — they are the daily operating system of everyone who bears the Champions' Leadership Global name.",
    items: [
      { id: "val-1", title: "Purpose", desc: "We believe every individual carries a God-given assignment. Our work begins where purpose is discovered — and we will not rest until every person we serve finds theirs." },
      { id: "val-2", title: "Personal Transformation", desc: "We are committed to the inside-out work of change. Real transformation is not cosmetic — it reshapes thinking, behaviour, and character from the core." },
      { id: "val-3", title: "Leadership", desc: "We raise leaders defined by character, not title. Every programme we run is ultimately a leadership development encounter." },
      { id: "val-4", title: "Influence", desc: "We equip people to carry weight in their spheres — family, career, community, and beyond. Influence is the currency of true leadership." },
      { id: "val-5", title: "Global Impact", desc: "Our vision does not stop at borders. We are raising a generation of champions whose impact will be felt across nations and generations." },
      { id: "val-6", title: "Legacy", desc: "We build for the long term. Everything we do is designed to outlast us — raising leaders whose lives, decisions, and values echo into the next generation." }
    ]
  },
  ceoSection: {
    homeLabel: "A Personal Note",
    homeTitle: "Our CEO says Welcome",
    homeSubtitle: "Hear directly from Jerry Oyedele, founder of Champions' Leadership Global",
    videoUrl: "https://www.youtube.com/embed/jAco6NX4I1k",
    pageBannerLabel: "Visioneer & Founder",
    pageBannerTitle: "Meet",
    pageBannerHighlight: "Jerry Oyedele",
    pageBannerSubtitle: "Leading with Purpose and Passion",
    photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260306-WA0029.jpg",
    name: "Jerry Oyedele",
    title: "Founder & CEO, Champions' Leadership Global",
    tags: ["Public Speaker", "Musicologist", "Mentor", "Choir Leader", "Educator"],
    degrees: [
      { id: "deg-1", degree: "B.A. Music — Second Class Upper", school: "Obafemi Awolowo University, Ile-Ife, Osun State, Nigeria", status: "Completed" },
      { id: "deg-2", degree: "M.A. Music", school: "Obafemi Awolowo University, Ile-Ife, Osun State, Nigeria", status: "Ongoing" }
    ],
    certifications: [
      { id: "cert-1", cert: "Write Like Mozart: An Introduction to Classical Music Composition", school: "National University of Singapore" },
      { id: "cert-2", cert: "Introduction to Classical Music", school: "Yale University" },
      { id: "cert-3", cert: "Fundamentals of Music Theory", school: "The University of Edinburgh" },
      { id: "cert-4", cert: "Introduction to Psychology", school: "Yale University" },
      { id: "cert-5", cert: "Songwriting: Writing the Lyrics", school: "Berklee College of Music" },
      { id: "cert-6", cert: "Exploring Piano Literature: The Piano Sonata", school: "University of Michigan" }
    ],
    bioIntro1: "Jerry Oyedele is a sought-after public speaker, musicologist, and mentor whose life is a living testimony of what it means to step into one's God-given purpose against all odds. He is the founder of Champions' Leadership Global, a leadership brand dedicated to purpose discovery, personal development, and leadership excellence — and the founder of Jebion Music, a gospel music brand committed to releasing the sound of the Kingdom.",
    bioIntro2: "He holds a Bachelor of Arts in Music (Second Class Upper) from Obafemi Awolowo University, Ile-Ife, and is currently pursuing a Master of Arts in Music at the same institution, where he continues to deepen his academic and creative formation.",
    quote: "I had to make the hardest decision of my life: leave engineering at 500 level and start music all over again from 100 level. That decision became the doorway to my purpose.",
    bioSections: [
      {
        id: "bio-1",
        heading: "The Journey to Purpose",
        paras: [
          "Jerry's story is not a conventional one. After years in the Engineering faculty at OAU, he felt a deep, undeniable pull toward music — a field he had loved all his life but never considered a \"serious\" path. The decision to leave and start over from 100 level was met with questions, doubts, and social pressure. But that radical act of obedience became the seed of everything he now leads.",
          "From that moment of surrender, Jerry began to understand purpose not as a destination but as a daily commitment to becoming who you were made to be. His personal journey gave him language for what millions experience: the tension between the life others expect and the life your soul craves. Champions' Leadership Global was born out of that tension."
        ]
      },
      {
        id: "bio-2",
        heading: "The Musicologist",
        paras: [
          "As a musicologist, Jerry brings over two decades of lived experience in music to his academic and creative pursuits. He is a prolific composer with over 300 original works produced in the last seven years alone — spanning choral, contemporary gospel, and orchestral forms. His compositions are not merely artistic expressions; they are spiritual declarations crafted to minister to the heart and glorify God.",
          "Through Jebion Music, Jerry is building a legacy of sacred music that bridges the gap between excellence and anointing. To ground his practice further, he has pursued certificate courses from world-class institutions including the National University of Singapore, Yale University, the University of Edinburgh, Berklee College of Music, and the University of Michigan."
        ]
      },
      {
        id: "bio-3",
        heading: "The Speaker & Mentor",
        paras: [
          "With over a decade on the public speaking circuit, Jerry has addressed students, professionals, church congregations, and various audiences across Nigeria. His messages are characterised by clarity, depth, and a rare ability to make abstract ideas about purpose feel immediately personal and actionable.",
          "As a mentor, Jerry works one-on-one and in group settings with young people navigating identity crises, career transitions, and leadership challenges. His approach is not merely motivational — it is transformational, drawing from Scripture, personal experience, and a rich understanding of human development."
        ]
      },
      {
        id: "bio-4",
        heading: "Faith & Church Life",
        paras: [
          "Jerry Oyedele is a committed worker in the vineyard of God. He serves as a choir leader in his local church denomination, using music as a vehicle for worship and intercession. He is also recognised as a gifted teacher of the Word.",
          "For Jerry, there is no separation between ministry and mission — every platform he occupies, whether a university auditorium, a conference hall, or a choir rehearsal, is an altar where lives can be shaped for eternity."
        ]
      }
    ],
    invitationTitle: "Invite Jerry to Speak",
    invitationDesc: "Jerry is available for conferences, summits, university programmes, church events, and corporate leadership sessions. Fill the form below and our team will be in touch within 48 hours."
  },
  eventsSection: {
    label: "Programs & Conferences",
    title: "Upcoming Events",
    subtitle: "Join us at our upcoming programmes and be part of a movement raising the next generation of champions.",
    upcoming: [
      {
        id: "up-1",
        quarter: "Q2 2026",
        title: "Kingdom Creative Conference 1.0",
        theme: "BEZALEEL: The Spirit of Wisdom & Understanding",
        loc: "Online (Virtual)",
        desc: "An inaugural conference exploring creativity, calling, and the Spirit of wisdom — where faith and excellence meet to unlock the creative potential God has placed in every believer.",
        tags: ["Virtual"]
      },
      {
        id: "up-2",
        quarter: "Q3 2026",
        title: "Champions Conference 2.0",
        theme: "RECALIBRATE: Setting Your Mind",
        loc: "OAU, Ile-Ife",
        desc: "Our flagship annual conference returns — challenging leaders to reset their thinking, realign their purpose, and step into a new season with clarity and conviction.",
        tags: ["Physical", "Virtual"]
      },
      {
        id: "up-3",
        quarter: "Q3 2026",
        title: "Certificate Course in Leadership",
        theme: "2026 Cohort",
        loc: "Physical & Virtual",
        desc: "A structured, practical leadership training programme designed to equip participants with the mindset, tools, and character needed to lead effectively in every sphere of life.",
        tags: ["Physical", "Virtual"]
      },
      {
        id: "up-4",
        quarter: "DEC 2026",
        title: "Retrospect 1.0",
        theme: "HOW FAR AND HOW WELL: Looking Back at 2026",
        loc: "Online (Virtual)",
        desc: "A reflective year-end gathering to look back at 2026 with honesty and gratitude — celebrating growth, acknowledging lessons, and setting our hearts towards the year ahead.",
        tags: ["Virtual"]
      }
    ],
    pastLabel: "Our History",
    pastTitle: "Past Events",
    pastSubtitle: "A record of the programmes, masterclasses, and conferences that have shaped our journey so far.",
    past: [
      {
        id: "past-1",
        quarter: "NOV 2024",
        title: "Champions Conference 1.0",
        theme: "TRANSFORMATION: Change | Evolve",
        loc: "Google Meet (Virtual)",
        desc: "Our inaugural flagship conference — a groundbreaking gathering designed to inspire participants to become the best version of themselves through mind transformation, personal evolution, and lasting change.",
        tags: ["Virtual", "Free"],
        dates: "15–16 Nov, 2024"
      },
      {
        id: "past-2",
        quarter: "FEB 2025",
        title: "Love & Patriotism",
        theme: "A Tool for National Development",
        loc: "Telegram",
        desc: "A Champions' Corner Exploits 365 February Special exploring how love and patriotism can be harnessed as tools for driving meaningful national development.",
        tags: ["Virtual"],
        dates: "11 Feb, 2025"
      },
      {
        id: "past-3",
        quarter: "FEB 2026",
        title: "Value & Value Systems Masterclass",
        theme: "The Hidden Framework That Shapes Your Destiny",
        loc: "Facebook Live (@Jerry Oyedele)",
        desc: "A Purpose Leadership Development Masterclass diving deep into how values influence choices and outcomes, building values that sustain growth, aligning purpose with principles, and breaking cycles through value change.",
        tags: ["Virtual", "Free"],
        dates: "13–14 Feb, 2026"
      },
      {
        id: "past-4",
        quarter: "MAR 2026",
        title: "3-Day Leadership Bootcamp",
        theme: "3 Days. 6 Core Pillars. One Defining Shift.",
        loc: "Google Meet (Virtual)",
        desc: "A transformative 3-day bootcamp covering self-awareness, purpose discovery, basics of leadership, personal transformation, leadership development, and influence — followed by one month of personal mentorship.",
        tags: ["Virtual", "Paid"],
        dates: "18–20 Mar, 2026"
      },
      {
        id: "past-5",
        quarter: "MAR 2025",
        title: "Next Generation Conference",
        theme: "The Power of Vision",
        loc: "Telegram Page",
        desc: "A Champions' Corner conference exploring the power of vision for the next generation — featuring speakers Jerry Oyedele (Founder, Champions' Corner), Afoluwa Oyegbile (Creative Director, Aphoenix), and Tolu Ayowole (CEO, Tap Music Africa).",
        tags: ["Virtual", "Free"],
        dates: "25 Mar, 2025"
      },
      {
        id: "past-6",
        quarter: "JUN 2025",
        title: "Redefining Failure Bootcamp",
        theme: "A 2-Day Virtual Bootcamp",
        loc: "Telegram (Virtual)",
        desc: "A Champions Leadership Academy 2-day virtual bootcamp tackling overcoming the feeling and fear of failure, why failure is important, failing forward, and fixed vs growth mindset.",
        tags: ["Virtual"],
        dates: "10–11 Jun, 2025"
      }
    ]
  },
  teamSection: {
    label: "The Champions",
    title: "Meet Our Team",
    subtitle: "A passionate, purpose-driven team committed to raising transformational leaders.",
    members: [
      { id: "team-1", name: "James Oluwapelumi Olatunbosun", designation: "Program Director", bio: "James is a science communicator and Engineering Physics student at OAU. He is committed to seeing young people thrive in career and character.", linkedin: "https://www.linkedin.com/in/james-olatunbosun", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260221-WA0000.jpg" },
      { id: "team-2", name: "Ogbaudu Oghenefegor Believe", designation: "Content Writer", bio: "A faith-based writer and founder of GAP INITIATIVE — an NGO empowering youth to discover their gifts and purpose.", linkedin: "", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260221-WA0001.jpg" },
      { id: "team-3", name: "Oluwatoyin Oluwabukola Yakubu", designation: "Head, Content", bio: "Oluwatoyin is passionate about helping people find healing from trauma and depression through honest conversations.", linkedin: "https://www.linkedin.com/in/oluwatoyin-yakubu-a2b1b6258", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260221-WA0005.jpg" },
      { id: "team-4", name: "Joseph Temitope Deborah", designation: "Community Manager", bio: "A communication advocate and leadership enthusiast passionate about purpose discovery and building impactful leaders.", linkedin: "https://www.linkedin.com/in/temitope-deborah-joseph-b24580227", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260304-WA0015.jpg" },
      { id: "team-5", name: "Promise Nseobong", designation: "Human Resource", bio: "An accounting student and creative voice running a YouTube channel on motivation and spoken-word poetry.", linkedin: "https://www.linkedin.com/in/nseobong-promise-02498a338", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260221-WA0006.jpg" },
      { id: "team-6", name: "Grace Temitope Babatunde", designation: "Admin", bio: "A communication specialist combining mastery of language with a passion for people-management and HR.", linkedin: "https://www.linkedin.com/in/gracetemibabatunde", photo: "https://ijsr.org.ng/wp-content/uploads/2026/03/IMG-20260304-WA0014.jpg" }
    ],
    volunteerLabel: "Join the Team",
    volunteerTitle: "Volunteer With Us —",
    volunteerHighlight: "Deploy Your Skill for Impact",
    volunteerDesc: "Do you have a gift — in design, writing, media, logistics, speaking, technology, or anything in between? We are always looking for passionate individuals who want to put their skills to work for a cause greater than themselves. Come build with us.",
    volunteerBtnText: "Chat Us on WhatsApp",
    volunteerWhatsApp: "https://wa.me/2348107772854"
  },
  blogSection: {
    label: "Insights & Wisdom",
    title: "Leadership Blog",
    subtitle: "Practical wisdom, purpose-driven insights, and leadership truths for the champion in you.",
    posts: [
      {
        id: "post-1",
        title: "Intentional Leadership",
        img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
        date: "Feb 9, 2026",
        category: "Leadership",
        excerpt: "Leadership is more than just a position; it is a conscious decision to influence and guide others towards a shared vision.",
        readTime: "5 min read",
        ctaHeading: "Ready to lead with intention and impact?",
        ctaSub: "Book a session and begin building the leader you were made to be.",
        fullContent: `Leadership is more than just a position; it is a conscious decision to influence and guide others towards a shared vision. In a world full of noise and distraction, the most impactful leaders are those who lead with intentionality.

True leadership begins from within. Before you can lead others, you must first learn to lead yourself. This means understanding your values, your purpose, and your non-negotiables. It means having the discipline to do what is right even when no one is watching.

Intentional leaders don't just react to circumstances — they create them. They set the tone for their teams and organisations by modelling the behaviour they wish to see. They invest in people not because it's convenient, but because they genuinely believe in the potential of every individual they encounter.

One of the greatest hallmarks of intentional leadership is the capacity to listen. Not just to respond, but to truly hear. The world is full of leaders who love to talk, but champions are those who understand that wisdom often comes from the voices around them.

As you step into your leadership journey today, ask yourself: Am I leading on purpose? Am I adding value to those around me? Am I building people, or simply using them? The answers to these questions will define the kind of leader you become — and the kind of legacy you leave behind.

Champions' Leadership Global exists to raise exactly this kind of leader: intentional, impactful, and enduring. The world doesn't need more bosses. It needs more champions.`
      },
      {
        id: "post-2",
        title: "Growth is Intentional: Becoming Better on Purpose",
        img: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&q=80&w=800",
        date: "Mar 10, 2026",
        category: "Personal Development",
        excerpt: "Growth does not happen by chance — it happens by choice. Real growth requires intention, consistent action, and the willingness to step beyond what is comfortable.",
        readTime: "6 min read",
        ctaHeading: "Ready to grow with intention and purpose?",
        ctaSub: "Book a session and take deliberate steps toward the best version of yourself.",
        fullContent: `Everyone wants to grow. We want to become better, do more, and achieve greater things. But wanting growth and actually growing are two very different things.

Growth does not happen by chance — it happens by choice. It is easy to assume that with time, things will automatically improve. But real growth requires intention. It requires conscious effort, consistent action, and the willingness to step beyond what is comfortable.

## Understanding Intentional Growth

Intentional growth is the decision to take responsibility for your personal development. It means you do not leave your life to chance or circumstances. Instead, you actively pursue improvement in your mindset, skills, habits, and character. Growth begins when you become aware of where you are and take deliberate steps toward where you want to be.

## The Difference Between Wishing and Growing

Many people remain in the cycle of wishing: "I want to be better." "I want to succeed." "I want to grow." But growth requires more than desire — it requires discipline. It shows up in the small, consistent actions you take daily: choosing learning over distraction, choosing discipline over convenience, choosing progress over perfection. These choices, though small, compound over time and produce real transformation.

## Stepping Beyond Your Comfort Zone

Growth and comfort rarely exist in the same space. To grow, you must be willing to stretch yourself — to try, to fail, to learn, and to try again. This process may feel uncomfortable, but it is necessary. Every level of growth requires a new version of you.

## The Role of Environment

Your environment plays a significant role in your growth journey. When you surround yourself with people who are committed to growth, you are more likely to stay accountable, inspired, and focused. The right environment challenges you, supports you, and pushes you toward becoming your best self.

## A Community That Supports Your Growth

At Champions' Leadership Global, we believe growth should be intentional and supported. We provide a platform where individuals are equipped with the right mindset, guidance, and community to grow into leaders who make meaningful impact. Through mentorship, leadership development, and purposeful conversations, we help you stay committed to your growth journey.

Growth is not accidental — it is a result of the decisions you make every day. If you are ready to stop wishing for growth and start living it, the decision begins with you.`
      },
      {
        id: "post-3",
        title: "The Power of Self-Leadership: Leading Yourself Before Others",
        img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=800",
        date: "Mar 17, 2026",
        category: "Leadership",
        excerpt: "Before leading others, you must first learn to lead yourself. Self-leadership is the foundation of true, authentic, and lasting influence.",
        readTime: "7 min read",
        ctaHeading: "Ready to master the art of leading yourself?",
        ctaSub: "Book a session and build the discipline, clarity, and character of a true leader.",
        fullContent: `Have you ever set goals for yourself and struggled to stay consistent? Maybe you started with excitement, full of motivation and clarity, but somewhere along the way, discipline became difficult and consistency faded. It is a common experience — and it reveals something important: before leading others, you must first learn to lead yourself.

Self-leadership is the foundation of true leadership. It is the ability to take responsibility for your actions, manage your emotions, stay committed to your goals, and direct your life with intention. Without self-leadership, influence becomes shallow. But with it, leadership becomes authentic and impactful.

## What is Self-Leadership?

Self-leadership is the practice of intentionally guiding your thoughts, behaviours, and decisions toward growth and purpose. It means showing up for yourself even when it is difficult. It means choosing discipline over convenience. It means taking ownership of your life instead of waiting for change. When you lead yourself effectively, you build the capacity to lead others with clarity, confidence, and integrity.

## Key Traits of Self-Leaders

Self-leadership is not a talent reserved for a few — it is a skill that can be developed. Discipline means doing what needs to be done, even when you don't feel like it. Accountability means taking responsibility for your choices and outcomes. Emotional Intelligence means understanding and managing your emotions effectively. Clarity means knowing your values, goals, and direction. These traits shape not only your personal growth but also how others experience your leadership.

## Why Self-Leadership Matters

Many people desire influence, impact, and success, but overlook the inner work required to sustain it. Self-leadership builds consistency. It strengthens resilience in difficult moments. It creates alignment between who you are and what you do. When you are able to lead yourself, you become someone others can trust, follow, and learn from.

## You Don't Have to Do It Alone

While self-leadership begins with personal responsibility, growth is accelerated in the right environment. Being part of a community of growth-driven individuals provides accountability, encouragement, and guidance. Mentors and like-minded peers help you stay focused and committed, especially when the journey becomes challenging.

At Champions' Leadership Global, we are passionate about raising individuals who lead with clarity, discipline, and purpose. We provide the environment, mentorship, and resources needed to help you develop self-leadership and grow into a leader who makes meaningful impact.

Leadership does not begin when others follow you. It begins the moment you choose to lead yourself.`
      },
      {
        id: "post-4",
        title: "Your Purpose: The Compass That Guides Your Life",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800",
        date: "Mar 21, 2026",
        category: "Purpose",
        excerpt: "Purpose is the inner compass that gives direction to your life — your unique function on earth and the contribution you are meant to make in the world.",
        readTime: "5 min read",
        ctaHeading: "Ready to discover and deploy your purpose?",
        ctaSub: "Book a clarity session and find the compass that will guide the rest of your life.",
        fullContent: `Have you ever tried to walk a path you were unfamiliar with without a guide or a compass? The experience can be confusing, discouraging, and uncertain. Life can feel the same way when it is lived without purpose.

Purpose is the inner compass that gives direction to your life. It can be simply described as your unique function on earth — the reason for your existence and the contribution you are meant to make in the world. When you understand your purpose, your identity becomes clearer and your path becomes more meaningful.

Just as a compass guides a traveller, purpose guides your decisions, growth, and impact. To keep your purpose alive, it is important to stay aligned with your Vision — seeing the future you are working toward; your Mission — understanding the work you are called to do; your Goals — taking intentional steps forward; and Determination — remaining committed despite challenges.

Another key part of living purposefully is community. No meaningful journey is meant to be walked alone. Surrounding yourself with like-minded individuals and mentors provides encouragement, guidance, and accountability.

At Champions' Leadership Global, we are committed to helping individuals discover their purpose, develop leadership capacity, and grow into people who create meaningful impact in their communities and beyond. If you are seeking clarity about your purpose and direction for growth, we invite you to book a discovery call with our team. Our experienced mentors are ready to guide and support you on your journey toward purposeful leadership and all-round development.

Your purpose can become the compass that guides your life.`
      }
    ]
  },
  reviewsSection: {
    label: "Community Voices",
    title: "What Champions",
    titleHighlight: "Are Saying",
    items: [
      {
        id: "rev-1",
        name: "Joseph Lilian Amanda",
        role: "Lagos",
        rating: 5,
        text: "Before CLG, leadership to me was just about the position and taking the lion's share. The Champions' Leadership Global impact gave me a better way to look at leadership — I can now tell you who I am in just three words: self-awareness. I know it is not just about living a million years on earth; the question is what am I leaving behind? What impact am I making? Who am I carrying along with me? Trust me, it was impactful. I am super happy I did not miss this opportunity."
      },
      {
        id: "rev-2",
        name: "Nseobong Promise",
        role: "Calabar",
        rating: 5,
        text: "Champions' Leadership Global has impacted me in many ways through its programmes, boot camps, and enlightening sessions. I have gained clarity on issues that have to do with vision and purpose, and I have also witnessed self-transformation in ways I did not expect."
      },
      {
        id: "rev-3",
        name: "Daniel",
        role: "Ile-Ife",
        rating: 5,
        text: "This year in January 2026, I learnt how to manage my time properly from the first webinar of the year. That single session changed how I approach my days and my responsibilities."
      },
      {
        id: "rev-4",
        name: "Oyeleye Deborah",
        role: "Osun State",
        rating: 5,
        text: "I attended the last leadership boot camp organised by Champions' Leadership Global and it was a real eye-opener to a lot of things I thought I knew, especially handling situations as a leader. I have learnt so much from the conferences and webinars that have been held. Special thanks to the convener and committee — keep up the good work."
      },
      {
        id: "rev-5",
        name: "Kayode Emmanuel",
        role: "Lagos",
        rating: 5,
        text: "Champions' Leadership Global has impacted me positively in the way of my thinking and reasoning about life and decision making."
      }
    ]
  },
  bookingSection: {
    bgImage: "https://images.unsplash.com/photo-1590650153855-d9e808231d41?auto=format&fit=crop&q=80&w=2000",
    label: "Begin Your Journey",
    title: "Book a",
    titleHighlight: "Session",
    subtitle: "Step into a collaborative environment designed to help you discover purpose, resolve identity questions, and refine your leadership edge.",
    sessionTypes: [
      "Purpose discovery",
      "Identity crisis",
      "Personal development and transformation",
      "Personal Leadership coaching",
      "Organizational Leadership coaching",
      "Others"
    ]
  },
  contactSection: {
    label: "Connect",
    title: "Contact Us",
    subtitle: "Have a question, collaboration idea, or just want to reach out? We would love to hear from you."
  },
  staffMail: {
    portalUrl: "mail.cleadglobal.org",
    domain: "cleadglobal.org",
    accounts: [
      {
        id: "staff-jerry-oyedele",
        fullName: "Jerry Oyedele",
        role: "Founder & CEO / Website Manager",
        department: "Executive & Leadership",
        username: "jerryoyedele",
        email: "jerryoyedele@cleadglobal.org",
        status: "Active",
        isAdmin: true,
        createdAt: "2026-03-01"
      }
    ]
  }
};